import { Dispatch } from "@reduxjs/toolkit";
import {
  toggleIsBtn,
  toggleBlinkValue,
  setMessage,
  startDateValue,
} from "src/store/media";

/**
 * Utility function to handle intention acceptance with proper timer cleanup and blinking reset
 * Ensures immediate visual feedback and prevents timer conflicts
 */
export const acceptIntentionWithReset = (
  dispatch: Dispatch,
  intentionName: string
): void => {
  console.log('🔄 Starting intention acceptance with reset:', intentionName);
  
  // Step 1: Stop current intention and clear all timers
  dispatch(toggleBlinkValue({ value: false }));
  dispatch(setMessage({ value: undefined }));
  
  // Clear any existing timers from localStorage and intervals
  const existingInterval = window.localStorage.getItem("intentionTimeInterval");
  if (existingInterval) {
    window.clearInterval(Number(existingInterval));
    window.localStorage.removeItem("intentionTimeInterval");
  }
  
  // Clear other intention-related localStorage items
  window.localStorage.removeItem("intentionMessage");
  window.localStorage.removeItem("intentionStartDate");
  
  // Step 2: Force a brief delay to ensure state changes propagate
  setTimeout(() => {
    console.log('✨ Starting new intention with fresh state:', intentionName);
    const newStartDate = String(new Date());
    
    // Start new intention with fresh state
    dispatch(setMessage({ value: intentionName }));
    dispatch(startDateValue({ value: newStartDate }));
    dispatch(toggleIsBtn({ value: true }));
    dispatch(toggleBlinkValue({ value: true })); // Explicit true for immediate visual feedback
    
    // Update localStorage with new intention data
    window.localStorage.setItem("intentionMessage", intentionName);
    window.localStorage.setItem("intentionStartDate", newStartDate);
    
    console.log('🎯 Intention successfully activated with blinking');
  }, 50); // 50ms delay ensures proper state reset
};

/**
 * Utility function to clear all intention-related timers and state
 * Used for cleanup operations
 */
export const clearAllIntentionTimers = (): void => {
  console.log('🧹 Clearing all intention timers');
  
  // Clear from localStorage
  const storedInterval = window.localStorage.getItem("intentionTimeInterval");
  if (storedInterval) {
    window.clearInterval(Number(storedInterval));
    window.localStorage.removeItem("intentionTimeInterval");
  }
  
  // Clear intention data
  window.localStorage.removeItem("intentionMessage");
  window.localStorage.removeItem("intentionStartDate");
}; 